import { render, staticRenderFns } from "./ClassroomGroupStudent.vue?vue&type=template&id=6fa774ea"
import script from "./ClassroomGroupStudent.vue?vue&type=script&lang=js"
export * from "./ClassroomGroupStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports